import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, homeFor } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import AideHome from "./pages/aide/AideHome";
import WeeklyReview from "./pages/aide/WeeklyReview";
import StudentProfile from "./pages/StudentProfile";
import StudentDashboard from "./pages/StudentDashboard";
import SchoolOverview from "./pages/coordinator/SchoolOverview";
import ReviewQueue from "./pages/supervisor/ReviewQueue";
import AdminPanel from "./pages/admin/AdminPanel";
import FormsLibrary from "./pages/FormsLibrary";
import Reports from "./pages/Reports";
import Legal from "./pages/Legal";
import CoachingInbox from "./pages/aide/CoachingInbox";
import GoalsPage from "./pages/GoalsPage";
import SpedHome from "./pages/sped/SpedHome";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-400 text-sm">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user.role)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/terms" element={<Legal kind="terms" />} />
          <Route path="/support" element={<Legal kind="support" />} />
          <Route path="/coaching" element={<Protected><CoachingInbox /></Protected>} />
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/aide" element={<Protected><AideHome /></Protected>} />
          <Route path="/weekly-review" element={<Protected><WeeklyReview /></Protected>} />
          <Route path="/students/:id" element={<Protected><StudentProfile /></Protected>} />
          <Route path="/students/:id/dashboard" element={<Protected><StudentDashboard /></Protected>} />
          <Route path="/overview" element={<Protected><SchoolOverview /></Protected>} />
          <Route path="/supervisor" element={<Protected><ReviewQueue /></Protected>} />
          <Route path="/admin" element={<Protected><AdminPanel /></Protected>} />
          <Route path="/forms" element={<Protected><FormsLibrary /></Protected>} />
          <Route path="/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/goals" element={<Protected><GoalsPage /></Protected>} />
          <Route path="/sped" element={<Protected><SpedHome /></Protected>} />
        </Routes>
      </BrowserRouter>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;
